import { getComputedDimensionFromCustomProperty } from "./CSS";

const scrollState = {
    scrollY: 0,
    scrollX: 0,
    top: "",
    overflow: "",
    position: "",
    width: "",
    scrollBehavior: ""
};

const saveState = () => {
    scrollState.scrollY = window.scrollY;
    scrollState.scrollX = window.scrollX;
    scrollState.overflow = document.body.style.getPropertyValue("overflow");
    scrollState.position = document.body.style.getPropertyValue("position");
    scrollState.width = document.body.style.getPropertyValue("width");
    scrollState.scrollBehavior = document.documentElement.style.getPropertyValue("scroll-behavior");
};

let isPrevented = false;

export const preventScroll = (additionalClass?: string): void => {
    if (isPrevented) return;
    saveState();
    const headerHeight = getComputedDimensionFromCustomProperty(
        document.documentElement,
        "--header-height",
        true
    ) as number;
    const scrollTop = (scrollState.scrollY - headerHeight) * -1;
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "calc(100vw - var(--scrollbar-width))";
    document.body.style.top = `${scrollTop}px`;
    document.documentElement.style.setProperty("scroll-behavior", "auto");
    const classes = ["scrolling-prevented"];
    if (additionalClass) {
        classes.push(additionalClass);
    }
    document.documentElement.classList.add.apply(document.documentElement.classList, classes);
    isPrevented = true;
};

export const releaseScroll = (additionalClass?: string): void => {
    document.body.style.setProperty("overflow", scrollState.overflow);
    document.body.style.setProperty("position", scrollState.position);
    document.body.style.setProperty("top", scrollState.top);
    document.body.style.setProperty("width", scrollState.width);
    window.scrollTo({ behavior: "auto", top: scrollState.scrollY, left: scrollState.scrollX });
    const classes = ["scrolling-prevented"];
    if (additionalClass) {
        classes.push(additionalClass);
    }
    document.documentElement.classList.remove.apply(document.documentElement.classList, classes);
    requestAnimationFrame(() => {
        document.documentElement.style.setProperty("scroll-behavior", scrollState.scrollBehavior);
        isPrevented = false;
    });
};
